import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService, Core2Config} from '../../shared';
import {WfIssueLabelListModel} from '../../../../../../models/aggregates/wf/issue/wf-issue-label-list-container.model';
import {ApiResponseModel, ApiVisa} from "../../shared";
import {WfIssueLabelCriteriaClass, WfIssueLabelCriteriaModel} from "../../../criteria/wf/issue/index";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class WfIssueLabelListService extends BaseApiTemplateService<WfIssueLabelListModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'issue-label-lists';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'issue-label-lists';
    this.httpClient = http;
  }
  getByCriteriaObservable(
    visa: ApiVisa, criteria?: WfIssueLabelCriteriaClass
  ): Observable<ApiResponseModel<WfIssueLabelListModel>> {
    const buildDocCriteria = new WfIssueLabelCriteriaModel(criteria);
    const apiUrl = visa.api_domain_url + this.endpoint_path;
    const UrlByCriteria = apiUrl + '/query?' + buildDocCriteria.query;
    return this.httpClient.get<ApiResponseModel<WfIssueLabelListModel>>
    (UrlByCriteria, this.getHttpHeader(visa));
  }
}
